import { c as _c } from "react/compiler-runtime";
import { useMutation, useQueryClient } from '@tanstack/react-query';
import services from '@/services';
import type { DeleteSurvey } from '@/services/surveyService';
export const useDeleteSurveyMutation = () => {
  const $ = _c(2);
  const queryClient = useQueryClient();
  let t0;
  if ($[0] !== queryClient) {
    t0 = {
      mutationFn: _temp,
      onSuccess: () => queryClient.invalidateQueries({
        queryKey: ["surveys-infinite"]
      })
    };
    $[0] = queryClient;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return useMutation(t0);
};
async function _temp(t0) {
  const {
    surveyId
  } = t0;
  await services.survey.deleteSurvey({
    surveyId
  });
}